<template>
    <div class="columns is-centered mt-6">
        <div class="column is-10 box is-block is-radiusless">
            <h5 class="is-primary is-uppercase has-text-weight-medium p-2">
                Ciudadanos en espera
            </h5>
            <OnlineUsersTable :signalRSocket="signalRSocket" :skills="skills" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import OnlineUsersTable from "./OnlineUsersTable.vue";

export default {
    name: "online-rooms-list",
    components: {
        OnlineUsersTable,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
        skills: {
            type: Array,
            default: null,
        },
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        isSupervisor() {
            let roles = this.oidcUser.role;
            return roles.indexOf("Supervisor") > -1;
        },
    },
    mounted() {
        if (!this.isSupervisor) {
            this.$router.push({
                name: "home",
            });
        }
    },
};
</script>
